import { extractDigits, normalizeIndicDigits } from 'shared/utilities/digits';

export function normalizeSaudiPhone(value) {
  const digits = extractDigits(value);
  if (!digits) {
    return '';
  }
  let rest = digits;
  if (rest.startsWith('00')) {
    rest = rest.slice(2);
  }
  if (rest.startsWith('966')) {
    rest = rest.slice(3);
  }
  if (rest.startsWith('0')) {
    rest = rest.slice(1);
  }
  if (rest.length === 9 && rest.startsWith('5')) {
    return `+966${rest}`;
  }
  return normalizeIndicDigits(value);
}

export function isLikelySaudiMobile(value) {
  const normalized = normalizeSaudiPhone(value);
  return /^\+9665\d{8}$/.test(normalized);
}

export function displayPhone(value) {
  const normalized = normalizeSaudiPhone(value);
  if (/^\+9665\d{8}$/.test(normalized)) {
    return `0${normalized.slice(4)}`;
  }
  return normalizeIndicDigits(value);
}
